import ReactPaginate from 'react-paginate';

export default ({ ...props }) => {
    //console.log(props.param);
    
    const param = props.param || props.param != '' ? '?'+props.param : ''
    return (
    <div>
        <div className="paging">
            <ReactPaginate
                pageCount={props.last_page}
                initialPage={parseInt(props.currPage)-1}
                hrefBuilder={(page) => '/berita/page/' + page + param }
                onPageChange={(data) => {
                    window.location.href = `/berita/page/${data.selected + 1}${param}`;
                }}
                disableInitialCallback={true}
                containerClassName ="pagination"
                breakClassName="page-item"
                breakLabel={<i>...</i>}
                pageClassName="page-item"
                previousClassName="page-item"
                nextClassName="page-item"
                pageLinkClassName="page-link d-flex justify-content-center align-items-center"
                previousLinkClassName="btn page-link"
                nextLinkClassName="btn page-link"
                previousLabel={<i className="arrow left"></i>}
                nextLabel={<i className="arrow right"></i>}
            />
        </div>
    </div>
)}